import { useMutation } from '@gogame/query';
import { useScreenMessage } from '@gogame/screens';

import { syncAudience } from 'scenes/CustomAudiences/Audiences/sources/audiences';

import { sync } from '../queryKeyFactory';

export const useSyncAudience = () => {
  const { showMessage } = useScreenMessage();
  const syncAUMutation = useMutation(sync(), syncAudience, {
    onSuccess: (_, params) =>
      showMessage(`Start update Audience «${params.name}»`),
  });

  const handleAction = async params => {
    await syncAUMutation.mutateAsync(params);
  };

  return [handleAction, syncAUMutation];
};
